<template>
  <div id="home">
    <!-- Modal overlay -->
    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
      <div class="modal-vip-content">
        <!-- Slides container -->
        <div class="slides-container">
          <div v-show="currentSlide === 1" key="slide-1" class="slide">
            <div class="slide-content">
              <div class="slide-image-container">
                <img src="./apps/chat/slide1.png" alt="Turbo VIP Feature 1" class="slide-image">
              </div>
              <!-- Text content -->
              <div class="p-6">
                <h2 class="font-bold mb-4 flex items-center justify-end" style="color: #31006F;">
                  {{ $t('slide_feature1_heading') }}
                </h2>
                <ul class="text-gray-800 mt-10 leading-relaxed text-left rtl-list">
                  <li class="mb-2">{{ $t('slide_feature1_desc_1') }}</li>
                  <li>{{ $t('slide_feature1_desc_2') }}</li>
                </ul>
              </div>
              <button class="next-btn" @click="nextSlide">ابدأ</button>
            </div>
            <div class="slide-dots">
              <span class="dot" v-for="(slide, index) in totalSlides" :key="index"
                :class="{ active: index + 1 === currentSlide }"></span>
            </div>
          </div>

          <div v-show="currentSlide === 2" key="slide-2" class="slide">
            <div class="slide-content">
              <div class="slide-image-container">
                <img src="./apps/chat/slide2.png" alt="Turbo VIP Feature 2" class="slide-image">
              </div>
              <!-- Text content -->
              <div class="p-6">
                <h2 class="font-bold mb-4 flex items-center justify-end" style="color: #31006F;">
                  {{ $t('slide_feature2_heading') }}
                </h2>
                <ul class="text-gray-800 mt-10 leading-relaxed text-left rtl-list">
                  <li class="mb-2">{{ $t('slide_feature2_desc_1') }}</li>
                  <li>{{ $t('slide_feature2_desc_2') }} </li>
                </ul>
              </div>
              <button class="next-btn" @click="nextSlide">التالي</button>
            </div>
            <div class="slide-dots">
              <span class="dot" v-for="(slide, index) in totalSlides" :key="index"
                :class="{ active: index + 1 === currentSlide }"></span>
            </div>
          </div>

          <div v-show="currentSlide === 3" key="slide-3" class="slide">
            <div class="slide-content">
              <div class="slide-image-container">
                <img src="./apps/chat/slide3.png" alt="Turbo VIP Feature 3" class="slide-image">
              </div>
              <!-- Text content -->
              <div class="p-6">
                <h2 class="font-bold mb-4 flex items-center justify-end" style="color: #31006F;">
                  {{ $t('slide_feature3_heading') }}
                </h2>
                <ul class="text-gray-800 mt-10 leading-relaxed text-left rtl-list">
                  <li class="mb-2">{{ $t('slide_feature3_desc_1') }}</li>
                  <li>{{ $t('slide_feature3_desc_2') }} </li>
                  <li>{{ $t('slide_feature3_desc_3') }} </li>
                  <li>{{ $t('slide_feature3_desc_4') }} </li>
                  <li>{{ $t('slide_feature3_desc_5') }} </li>
                  <li>{{ $t('slide_feature3_desc_6') }} </li>
                  <li>{{ $t('slide_feature3_desc_7') }} </li>
                </ul>
              </div>
              <button class="next-btn" @click="nextSlide">التالي</button>
            </div>
            <div class="slide-dots">
              <span class="dot" v-for="(slide, index) in totalSlides" :key="index"
                :class="{ active: index + 1 === currentSlide }"></span>
            </div>
          </div>

          <div v-show="currentSlide === 4" key="slide-4" class="slide">
            <div class="slide-content">
              <div class="slide-image-container">
                <img src="./apps/chat/slide4.png" alt="Turbo VIP Feature 2" class="slide-image">
              </div>
              <!-- Text content -->
              <div class="p-6">
                <h2 class="font-bold mb-4 flex items-center justify-end" style="color: #31006F;">
                  {{ $t('slide_feature4_heading') }}
                </h2>
                <ul class="text-gray-800 mt-10 leading-relaxed text-left rtl-list">
                  <li class="mb-2">{{ $t('slide_feature4_desc_1') }}</li>
                </ul>
              </div>
              <button class="next-btn" @click="nextSlide">التالي</button>
            </div>
            <div class="slide-dots">
              <span class="dot" v-for="(slide, index) in totalSlides" :key="index"
                :class="{ active: index + 1 === currentSlide }"></span>
            </div>
          </div>

          <div v-show="currentSlide === 5" key="slide-5" class="slide ">

            <div class="flex flex-row rounded-lg overflow-hidden max-w-2xl" dir="rtl">

              <!-- Right Section (Price & Button) -->
              <div class="w-1/2 bg-white p-6 text-center flex flex-col justify-center">
                <div class="mt-6">
                  <span class="text-gray-600 mb-1">{{ $t('slide_feature5_right_heading') }}</span>
                  <h2 class="text-sm font-bold mb-2"> {{ $t('slide_feature5_right_desc_1') }}</h2>
                  <p class="text-lg font-bold text-gray-800 mb-4">750 <span class="text-sm font-normal">
                      {{ $t('slide_feature5_right_desc_2') }}
                      </span></p>
                </div>
                <a href="https://wa.me/201208491111" target="_blank" @click="closeModal"
                  class="text-white text-sm py-2 px-6 rounded-full mt-2" style="background-color: #31006F;">
                  <strong>اشترك الآن</strong>
                </a>
              </div>

              <!-- Left Section (Features) -->
              <div class="w-1/2 relative" style="background-color: #F7F7FC;">
                <span class="absolute top-3 right-0 text-xl p-3" @click="closeModal">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>                  
                <div class="mt-6 p-6">
                  <h3 class="text-sm text-left text-gray-600 mb-4 font-bold">{{ $t('slide_feature5_left_heading') }}</h3>
                  <ul class="text-sm text-gray-800">
                    <li class="flex items-center mb-4">
                      <span class="mr-2 mt-1 text-lg">
                        <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26Z"
                            fill="#17C653" />
                          <path d="M7.1167 13.8396L10.4785 17.2014L18.8831 8.79688" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      {{ $t('slide_feature5_left_desc_1') }}
                    </li>
                    <li class="flex items-center">
                      <span class="mr-2 mb-3 text-lg">
                        <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13 26C20.1799 26 26 20.1799 26 13C26 5.8201 20.1799 0 13 0C5.8201 0 0 5.8201 0 13C0 20.1799 5.8201 26 13 26Z"
                            fill="#17C653" />
                          <path d="M7.1167 13.8396L10.4785 17.2014L18.8831 8.79688" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      <span class="text-left">
                          {{ $t('slide_feature5_left_desc_2') }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <ModalNotification v-if="showRequestsModal && checkAuthHasShowModalChangePrice">
      <template v-slot:content>
        <div class="modal-content flex items-center">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20.2197 0.219672L16.5 3.93939V1.74994C16.5 1.55103 16.421 1.36026 16.2803 1.21961C16.1397 1.07896 15.9489 0.999942 15.75 0.999942C15.5511 0.999942 15.3603 1.07896 15.2197 1.21961C15.079 1.36026 15 1.55103 15 1.74994V5.74994C15.0008 5.94862 15.08 6.13895 15.2205 6.27943C15.361 6.41992 15.5513 6.49918 15.75 6.49994H19.75C19.9489 6.49994 20.1397 6.42092 20.2803 6.28027C20.421 6.13962 20.5 5.94885 20.5 5.74994C20.5 5.55103 20.421 5.36026 20.2803 5.21961C20.1397 5.07896 19.9489 4.99994 19.75 4.99994H17.5606L21.2803 1.28021C21.4201 1.1394 21.4983 0.948925 21.498 0.750508C21.4976 0.55209 21.4186 0.361902 21.2783 0.2216C21.138 0.081297 20.9479 0.00231572 20.7494 0.00195437C20.551 0.00159302 20.3605 0.0798811 20.2197 0.219672Z"
              fill="black" />
            <path
              d="M10.75 7.86377C11.0331 7.86406 11.3047 7.97664 11.5049 8.17683C11.7052 8.37702 11.8179 8.64847 11.8183 8.93164C11.8183 9.13055 11.8974 9.32132 12.038 9.46197C12.1787 9.60262 12.3694 9.68164 12.5683 9.68164C12.7672 9.68164 12.958 9.60262 13.0987 9.46197C13.2393 9.32132 13.3183 9.13055 13.3183 8.93164C13.3164 8.38349 13.1387 7.85042 12.8114 7.4107C12.4841 6.97097 12.0245 6.64776 11.5 6.48853V5.75C11.5 5.55109 11.421 5.36032 11.2803 5.21967C11.1397 5.07902 10.9489 5 10.75 5C10.5511 5 10.3603 5.07902 10.2196 5.21967C10.079 5.36032 9.99998 5.55109 9.99998 5.75V6.48853C9.41158 6.66675 8.90695 7.05071 8.57827 7.57027C8.24959 8.08982 8.1188 8.71028 8.20979 9.3183C8.30078 9.92632 8.60749 10.4813 9.07387 10.8819C9.54026 11.2824 10.1352 11.5018 10.75 11.5C10.9612 11.5 11.1677 11.5627 11.3433 11.6801C11.5189 11.7975 11.6558 11.9643 11.7366 12.1595C11.8174 12.3546 11.8385 12.5694 11.7973 12.7766C11.7561 12.9837 11.6544 13.174 11.505 13.3234C11.3556 13.4728 11.1653 13.5745 10.9582 13.6157C10.751 13.6569 10.5363 13.6358 10.3411 13.555C10.1459 13.4742 9.97911 13.3373 9.86173 13.1617C9.74434 12.9861 9.68166 12.7796 9.68161 12.5684C9.68161 12.3694 9.6026 12.1787 9.46195 12.038C9.32129 11.8974 9.13053 11.8184 8.93161 11.8184C8.7327 11.8184 8.54194 11.8974 8.40129 12.038C8.26063 12.1787 8.18161 12.3694 8.18161 12.5684C8.18359 13.1165 8.36127 13.6496 8.68854 14.0893C9.01582 14.529 9.47546 14.8522 9.99998 15.0115V15.75C9.99998 15.9489 10.079 16.1397 10.2196 16.2803C10.3603 16.421 10.5511 16.5 10.75 16.5C10.9489 16.5 11.1397 16.421 11.2803 16.2803C11.421 16.1397 11.5 15.9489 11.5 15.75V15.0115C12.0884 14.8332 12.593 14.4493 12.9217 13.9297C13.2504 13.4102 13.3812 12.7897 13.2902 12.1817C13.1992 11.5737 12.8925 11.0187 12.4261 10.6181C11.9597 10.2176 11.3648 9.99816 10.75 10C10.6094 10.0004 10.4702 9.97312 10.3402 9.91963C10.2103 9.86615 10.0921 9.78754 9.99259 9.68831C9.89306 9.58909 9.81409 9.47119 9.76021 9.34139C9.70632 9.21159 9.67859 9.07243 9.67859 8.93188C9.67859 8.79134 9.70632 8.65218 9.76021 8.52238C9.81409 8.39257 9.89306 8.27468 9.99259 8.17546C10.0921 8.07623 10.2103 7.99762 10.3402 7.94414C10.4702 7.89065 10.6094 7.86334 10.75 7.86377Z"
              fill="black" />
            <path
              d="M20.75 10C20.5511 10.0001 20.3604 10.0791 20.2197 10.2197C20.0791 10.3604 20.0001 10.5511 20 10.75C20 12.5795 19.4575 14.3679 18.4411 15.889C17.4247 17.4102 15.98 18.5958 14.2898 19.2959C12.5996 19.996 10.7397 20.1792 8.94542 19.8223C7.15109 19.4654 5.5029 18.5844 4.20927 17.2907C2.91563 15.9971 2.03465 14.3489 1.67774 12.5546C1.32083 10.7603 1.50401 8.90039 2.20412 7.21018C2.90423 5.51996 4.08983 4.07531 5.61098 3.05891C7.13213 2.0425 8.92053 1.5 10.75 1.5C10.9489 1.5 11.1397 1.42098 11.2803 1.28033C11.421 1.13968 11.5 0.948912 11.5 0.75C11.5 0.551088 11.421 0.360322 11.2803 0.21967C11.1397 0.0790177 10.9489 0 10.75 0C8.62386 0 6.54545 0.630477 4.77762 1.8117C3.0098 2.99293 1.63194 4.67185 0.8183 6.63615C0.0046578 8.60046 -0.208228 10.7619 0.206563 12.8472C0.621354 14.9325 1.64519 16.848 3.14861 18.3514C4.65202 19.8548 6.56749 20.8787 8.65278 21.2934C10.7381 21.7082 12.8995 21.4953 14.8639 20.6817C16.8282 19.8681 18.5071 18.4902 19.6883 16.7224C20.8695 14.9546 21.5 12.8761 21.5 10.75C21.5 10.5511 21.4209 10.3604 21.2803 10.2197C21.1396 10.0791 20.9489 10.0001 20.75 10Z"
              fill="black" />
          </svg>
          <span class="mx-2">
            تم تغير سعر الطرد رقم {{ orderRequestsData.order_id }}
          </span>
        </div>
        <div class="w-full px-5" style="border: 0.5px solid #9E9E9E;border-radius: 3px; line-height: 3;">
          <p>الاسم : <span class="font-bold">{{ orderRequestsData.captain.name }}</span></p>
          <p>محتوي الطرد : <span class="font-bold">{{ orderRequestsData.order.order_summary }}</span></p>
          <p>المحافظه : <span class="font-bold">{{ orderRequestsData.order.government_name }}</span></p>
          <p>المنطقه : <span class="font-bold">{{ orderRequestsData.order.area }}</span></p>
          <p>السعر القديم : <span class="font-bold">{{ orderRequestsData.order_amount }}</span></p>
          <p class="text-danger font-extrabold">السعر الجديد : <span class="font-extrabold">{{
            orderRequestsData.new_amount
              }}</span></p>
        </div>
        <div class="w-full mt-8 mb-3" v-if="orderRequestsData.partial_return">
          <h3 class="pr-5" style="font-size: medium">{{ $t("has_partial_returned") }}</h3>
        </div>
      </template>
      <template v-slot:first-btn>
        <button class="third-btn px-12 mt-5 text-white w-1/2 rounded-full" style="background-color: #31006F;"
          @click="changeStatusOrderChangeRequestsPrice(true)">
          اوافق
        </button>
      </template>
      <template v-slot:third-btn>
        <button class="third-btn mt-5 px-10 w-1/2 rounded-full" @click="changeStatusOrderChangeRequestsPrice(false)">
          لا اوافق
        </button>
      </template>
    </ModalNotification>
    <Modal v-if="showModal" @closeModal="closePopup()">
      <template v-slot:icon>
        <img src="@/assets/images/elements/drone.svg" alt="Something wrong" />
      </template>
      <template v-slot:content>
        <p class="modal-content">تم تعديل تكاليف الشحن الى الاسعار الثابتة</p>
      </template>
      <template v-slot:second-btn>
        <button class="first-btn" @click.stop="(showNumbersModal = true), (showModal = false)">
          اتصل بنا
        </button>
      </template>
    </Modal>
    <Modal v-if="showNumbersModal" @closeModal="closePopup()">
      <template v-slot:content>
        <h5 class="font-bold w-full text-center">ارقام الاستعلام</h5>
        <p class="modal-content modal-phone my-4">
          <feather-icon icon="PhoneIcon" svgClasses="text-primary h-5 w-5" class="mr-2" />{{ phone1 }}
        </p>
        <p class="modal-content modal-phone">
          <feather-icon icon="PhoneIcon" svgClasses="text-primary h-5 w-5" class="mr-2" />{{ phone2 }}
        </p>
      </template>

      >
    </Modal>
    <Modal v-if="isFreezed" @closeModal="closePopup()">
      <template v-slot:icon>
        <img src="@/assets/images/elements/drone.svg" alt="Something wrong" />
      </template>
      <template v-slot:content>
        <p class="modal-content"><span v-html="$t('accountFreezed')"></span></p>
      </template>
    </Modal>
    <ModalAddVue v-if="activeSurveysModal" :title="surveyData.survey_question">
      <template #body>
        <div class="modal-input">
          <surveyInput v-if="!loadingUpdateClientData" :typeInput="surveyData.survey_type" v-model="updateClientData" />
        </div>
      </template>
      <template #footer>
        <button v-if="!loadingUpdateClientData" @click="submitData()" class="first-btn"
          :class="[{ 'active-btn': isFormValid }]" :disabled="!isFormValid">
          تأكيد
        </button>
        <button class="first-btn loading-form flex justify-center" v-else>
          <spinnerColor />
        </button>
      </template>
    </ModalAddVue>
    <div class="p-6 loading-table" v-show="loadHome">
      <spinner-color />
    </div>
    <div id="dashboard-analytics" v-show="!loadHome">
      <div class="dashboard-top" style="margin-bottom: 1.5rem !important">
        <!-- CARD: features -->
        <TurboFeatures />
        <!-- CARD: PROFILE -->
        <div div class="my-profile">
          <div class="profile-card">
            <img src="@/assets/images/elements/user2.svg" loading="lazy" class="mr-4" alt="User" width="39.75" />
            <div class="info-card flex justify-between">
              <div>
                <h4 style="line-height: 1.3125rem">
                  {{ hasAccess ? client.name : user.first_name }}
                </h4>
                <span class="content-card">
                  <input type="hidden" ref="copyText" :value="hasAccess ? client.email : user.email" />
                  {{ hasAccess ? client.email : user.email }}
                  <span @click="copyText('copyText')" style="cursor: pointer">
                    <svg style="transform: translate(-5px, 2px)" id="Icon_ionic-ios-copy"
                      data-name="Icon ionic-ios-copy" xmlns="http://www.w3.org/2000/svg" width="9.521" height="11.901"
                      viewBox="0 0 9.521 11.901">
                      <path id="Path_1006" data-name="Path 1006"
                        d="M23.881,3.584h2.231a.149.149,0,0,0,.149-.149h0a.692.692,0,0,0-.248-.528L24.1,1.316a.927.927,0,0,0-.511-.183h0a.183.183,0,0,0-.183.183v1.8A.475.475,0,0,0,23.881,3.584Z"
                        transform="translate(-16.74 -1.13)" fill="#6e6b7b" />
                      <path id="Path_1007" data-name="Path 1007"
                        d="M14.166,3.109V1.125H10.918a.8.8,0,0,0-.793.793v8.331a.8.8,0,0,0,.793.793h5.951a.8.8,0,0,0,.793-.793V4.224h-2.38A1.117,1.117,0,0,1,14.166,3.109Z"
                        transform="translate(-8.141 -1.125)" fill="#6e6b7b" />
                      <path id="Path_1008" data-name="Path 1008"
                        d="M5.789,13.857V5.625h-.5a.8.8,0,0,0-.793.793v8.728a.8.8,0,0,0,.793.793h6.347a.8.8,0,0,0,.793-.793v-.5H6.583A.8.8,0,0,1,5.789,13.857Z"
                        transform="translate(-4.5 -4.038)" fill="#6e6b7b" />
                    </svg>
                  </span>
                </span>
                <span class="content-card">{{ $t("typeProducts") }} : {{ client.products_type }}</span>
                <span class="content-card flex items-center" style="margin-top: 0.1875rem">{{ $t("yourCode") }} :
                  <span class="code">{{ client.code }}</span>
                </span>
              </div>
              <div class="flex items-end" style="flex-direction: column">
                <div data-tour-step="7" class="mb-4 flex items-center cursor-pointer"
                  style="min-width: 95px; border-radius: 4px"
                  @click="$router.push('/setting-main-info').catch(() => { })">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.07" height="12.073" viewBox="0 0 12.07 12.073">
                    <path id="Icon_ionic-ios-settings" data-name="Icon ionic-ios-settings"
                      d="M15.574,10.535a1.553,1.553,0,0,1,1-1.449,6.156,6.156,0,0,0-.745-1.795,1.574,1.574,0,0,1-.632.135,1.55,1.55,0,0,1-1.418-2.181A6.138,6.138,0,0,0,11.984,4.5a1.552,1.552,0,0,1-2.9,0,6.156,6.156,0,0,0-1.795.745A1.55,1.55,0,0,1,5.874,7.426a1.523,1.523,0,0,1-.632-.135,6.293,6.293,0,0,0-.742,1.8,1.553,1.553,0,0,1,0,2.9,6.156,6.156,0,0,0,.745,1.795,1.55,1.55,0,0,1,2.046,2.046,6.192,6.192,0,0,0,1.795.745,1.549,1.549,0,0,1,2.892,0,6.156,6.156,0,0,0,1.795-.745,1.552,1.552,0,0,1,2.046-2.046,6.192,6.192,0,0,0,.745-1.795A1.561,1.561,0,0,1,15.574,10.535Zm-5.01,2.511a2.515,2.515,0,1,1,2.515-2.515A2.514,2.514,0,0,1,10.563,13.046Z"
                      transform="translate(-4.5 -4.5)" fill="#6e6b7b" />
                  </svg>
                  <span style="
                      display: inline-block;
                      margin-right: 0.5rem;
                      font-size: 0.75rem;
                      color: #6e6b7b;
                      text-decoration: underline;
                    ">{{ $t("accountSettings") }}</span>
                </div>

                <div class="mb-4 flex items-center cursor-pointer" style="min-width: 95px"
                  @click="$router.push('/termsAndConditions').catch(() => { })">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12.105" height="12.105" viewBox="0 0 12.105 12.105">
                    <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                      d="M12.667,6.615A6.052,6.052,0,1,1,6.615.563,6.052,6.052,0,0,1,12.667,6.615ZM6.777,2.564A3.161,3.161,0,0,0,3.933,4.12a.293.293,0,0,0,.066.4l.847.642a.293.293,0,0,0,.407-.052c.436-.553.735-.874,1.4-.874.5,0,1.115.321,1.115.8,0,.365-.3.553-.794.829-.574.322-1.334.722-1.334,1.724v.1a.293.293,0,0,0,.293.293H7.3a.293.293,0,0,0,.293-.293V7.656c0-.695,2.03-.724,2.03-2.6A2.784,2.784,0,0,0,6.777,2.564ZM6.615,8.616A1.123,1.123,0,1,0,7.738,9.739,1.124,1.124,0,0,0,6.615,8.616Z"
                      transform="translate(-0.563 -0.563)" fill="#6e6b7b" />
                  </svg>
                  <span style="
                      display: inline-block;
                      margin-right: 0.5rem;
                      font-size: 0.75rem;
                      color: #6e6b7b;
                      text-decoration: underline;
                    ">{{ $t("termsCondition") }}</span>
                </div>

                <span class="supp" :class="[{ 'blur': !showBalance }]" v-if="hasAccess">{{ $t("nextSupply") }} : {{
                  !isNaN(next_supply) ? Number(next_supply).toFixed(2) : next_supply }}
                  {{ $t("pounds") }}</span>
              </div>
            </div>
          </div>
          <!-- Show Blaance -->
          <transition>
            <p class="text-center font-bold flex items-center justify-center gap-3  relative  translate cursor-pointer"
              @click="fetchBalance">
              <span class="font-bold " v-if="!showBalance && !spin">اظهار الرصيد</span>
              <svg v-if="!showBalance && !spin" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                viewBox="0 0 22.172 19">
                <path id="Icon_ionic-md-eye-off" data-name="Icon ionic-md-eye-off"
                  d="M13.338,8.5a5.026,5.026,0,0,1,5.042,5,4.812,4.812,0,0,1-.361,1.831l2.944,2.919a11.828,11.828,0,0,0,3.459-4.75A11.94,11.94,0,0,0,9.316,6.7l2.177,2.162A4.985,4.985,0,0,1,13.338,8.5ZM3.259,5.772l2.3,2.281.465.46A11.772,11.772,0,0,0,2.25,13.5a11.958,11.958,0,0,0,15.5,6.66l.426.421L21.131,23.5l1.282-1.272L4.536,4.5ZM8.831,11.3l1.564,1.549a2.834,2.834,0,0,0-.079.648,3.008,3.008,0,0,0,3.023,3,2.844,2.844,0,0,0,.653-.079l1.564,1.549A5.016,5.016,0,0,1,8.3,13.49,4.942,4.942,0,0,1,8.831,11.3Zm4.344-.777,3.177,3.152.02-.158a3.008,3.008,0,0,0-3.023-3Z"
                  transform="translate(-2.25 -4.5)" fill="#848484" />
              </svg>
              <spinner-color v-if="spin"></spinner-color>
            </p>
          </transition>
          <div class="show-balance cursor-pointer " :class="[{ 'blur': !showBalance }]">

            <div class="cash-card flex justify-between   text-center" @click="fetchBalance">
              <div class="flex cash-card1" style="flex-direction: column">
                <svg xmlns="http://www.w3.org/2000/svg" width="32.17" height="32.17" viewBox="0 0 32.17 32.17">
                  <path v-if="hasAccess" id="Icon_material-monetization-on" data-name="Icon material-monetization-on"
                    d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                    transform="translate(-3 -3)" fill="#31006F" />
                  <path v-else id="Icon_material-monetization-on" data-name="Icon material-monetization-on"
                    d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                    transform="translate(-3 -3)" fill="#00000075" />
                </svg>
                <span class="cash1" v-if="hasAccess">{{ total_balance }} {{ $t("pounds") }}</span>
                <span class="cash1" style="color: #212121" v-else>ليس لديك صلاحية</span>
                <span>{{ $t("totalAccount") }}</span>
              </div>
              <div class="flex cash-card2" style="flex-direction: column">
                <svg xmlns="http://www.w3.org/2000/svg" width="32.17" height="32.17" viewBox="0 0 32.17 32.17">
                  <path v-if="hasAccess" id="Icon_material-monetization-on" data-name="Icon material-monetization-on"
                    d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                    transform="translate(-3 -3)" fill="#28c76f" />
                  <path v-else id="Icon_material-monetization-on" data-name="Icon material-monetization-on"
                    d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                    transform="translate(-3 -3)" fill="#00000075" />
                </svg>
                <span class="cash2" v-if="hasAccess">{{ total_supplied_balance }} {{ $t("pounds") }}</span>
                <span class="cash2" style="color: #212121" v-else>ليس لديك صلاحية</span>
                <span>{{ $t("retractableBalance") }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- CARD: ORDER RECIEVED -->
        <TurboShop />
      </div>

      <vs-divider class="mb-5 mt-0" />

      <div class="second-section">
        <div class="last-orders">
          <div class="header-last-orders">
            <h3>
              <feather-icon icon="PackageIcon" svgClasses="h-6 w-6" class="mr-2"></feather-icon>
              أخر الطرود المحفوظة
            </h3>
            <button @click="$router.push(`/SavedOrder`).catch(() => { })">
              <feather-icon icon="PackageIcon" svgClasses="h-6 w-6" class="mr-2"></feather-icon>
              الطرود المحفوظة
            </button>
          </div>
          <data-table-order :data="this.$store.state.dataList.orders" :header="header" :body="body" :pageName="pageName"
            :titlePage="titlePage" />
        </div>
        <div class="chart-search-ordres">
          <!-- CARD: ORDER RECIEVED -->
          <div class="given-order">
            <div style="padding: 1.125rem; border-radius: 1rem; height: 100%" class="bg-white">
              <div class="flex justify-between" style="position: relative; z-index: 2">
                <div>
                  <span style="font-size: 0.875rem">{{ $t("numberOfOrder") }}
                    <span style="
                        display: inline-block;
                        transform: translate(-0.125rem, 0.1875rem);
                      ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12.004" height="12.004"
                        viewBox="0 0 12.004 12.004">
                        <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle"
                          d="M12.567,6.565a6,6,0,1,1-6-6A6,6,0,0,1,12.567,6.565ZM5.87,9.743,10.324,5.29a.387.387,0,0,0,0-.548l-.548-.548a.387.387,0,0,0-.548,0L5.6,7.826,3.9,6.13a.387.387,0,0,0-.548,0l-.548.548a.387.387,0,0,0,0,.548L5.323,9.743a.387.387,0,0,0,.548,0Z"
                          transform="translate(-0.563 -0.563)" fill="#28c76f" />
                      </svg>
                    </span>
                  </span>
                  <span style="
                      display: block;
                      font-size: 1.5rem;
                      color: #31006f;
                      line-height: 2.9375rem;
                      font-weight: 600;
                    ">{{ this.chart.total_given }} {{ $t("order") }}</span>
                </div>
              </div>
              <div style="position: relative; top: -75px; z-index: 0">
                <Pie :height="180" :width="270" :chart-data="chartData" :chart-options="chartOptions" />
              </div>
            </div>
          </div>
          <!-- CARD: SEARCH -->
          <div class="search">
            <div class="search-header">
              <h4 class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-3" width="16.414" height="16.653"
                  viewBox="0 0 16.414 16.653">
                  <g id="search" transform="translate(-2.3 -2.061)">
                    <circle id="Ellipse_274" data-name="Ellipse 274" cx="6" cy="6" r="6"
                      transform="translate(3.3 3.061)" fill="none" stroke="#6e6b7b" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2" />
                    <line id="Line_69" data-name="Line 69" x1="3.469" y1="3.469" transform="translate(13.831 13.831)"
                      fill="none" stroke="#6e6b7b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                  </g>
                </svg>
                البحث عن الطرود الدولية
              </h4>
            </div>
            <div class="search-body" data-tour-step="5">
              <div class="badge-new">
                <div>جديد</div>
              </div>
              <span class="icon-search">
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M71.9428 21.5158C71.348 22.0827 67.6715 20.9489 63.3766 18.6817C63.0733 18.392 62.8062 18.392 62.5029 18.1271L48.2571 23.5176L47.1163 23.2522L57.6608 15.594C54.8212 13.6039 51.3876 11.6383 49.3854 10.1911L44.4956 13.0737L44.2285 12.8083L48.2327 9.09382C47.9293 8.82838 47.9293 8.82838 47.9293 8.5511H48.5241L49.3491 3.4254H49.628L50.2104 9.06949C52.2125 9.92555 55.9252 11.3491 59.3351 13.0494L59.6628 0L60.8036 0.566945L63.9096 15.2929C64.2221 15.5977 64.6192 15.8033 65.0504 15.8836C69.0784 18.1508 72.4883 20.6716 71.9422 21.5158H71.9428Z"
                    fill="#31006F" />
                  <path
                    d="M65.1228 15.8836C64.6922 15.8033 64.2951 15.5977 63.982 15.2929L60.8034 0.566945L59.6626 0L59.3712 13.0737C55.9618 11.3734 52.2486 9.94982 50.2464 9.09375L49.6641 3.4254H49.3489L48.5114 8.52684H47.9166C47.9166 8.80412 47.9166 8.80412 48.22 9.06956L44.2158 12.784L44.4953 13.0737L49.3488 10.2277C51.351 11.6749 54.7846 13.6407 57.6242 15.6306L47.0798 23.2888L48.2205 23.5543L62.4663 18.1873C62.7696 18.4528 63.0367 18.4528 63.34 18.7419C67.6357 21.0091 71.312 22.143 71.9062 21.576C72.4885 20.6715 69.0786 18.1506 65.1232 15.8834L65.1228 15.8836Z"
                    fill="#31006F" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M46.7642 5.9822L44.2281 9.8415C42.3588 9.41239 40.4541 9.15019 38.5377 9.05758C32.5266 9.0425 26.6184 10.6045 21.409 13.5856C16.2002 16.5668 11.8747 20.8617 8.86999 26.0357C5.86526 31.2104 4.28731 37.0812 4.29605 43.0552C4.29605 55.2604 11.443 65.4516 20.2877 72C8.29964 72 0 53.5842 0 43.0552C0.0195 32.9079 4.08762 23.1826 11.312 16.0126C18.5371 8.84311 28.3284 4.81483 38.5374 4.81152C41.2989 5.05327 44.0448 5.44415 46.764 5.98148L46.7642 5.9822Z"
                    fill="#31006F" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M64.2367 31.743C64.0644 31.5928 63.9485 31.3887 63.909 31.1642C62.6501 28.1071 60.8181 25.3154 58.5094 22.9389L58.2548 22.722C58.0972 22.5771 57.9634 22.4204 57.8301 22.2756L53.2312 23.9279L52.7946 24.3619L53.098 24.9046H53.6684L53.9354 26.0261L55.1488 25.4834L55.4153 26.9188H54.8449L53.9592 26.6415L53.1218 26.9188L51.981 28.0403L50.7676 28.3418L50.5006 29.4633L51.071 29.7648L50.7676 30.3075L49.6393 30.0302L48.2321 30.3075V32.5871L49.0933 32.8768H51.0711L51.3625 32.298L52.5033 30.6214H53.3646L54.202 30.0302L54.5054 30.6214L56.5075 31.7429L56.2042 32.2975L55.4155 32.298L55.6825 32.5877L56.2529 32.8773L56.8233 32.5877V31.7434L57.3937 31.4538L57.0898 31.1641L55.6582 30.6214L55.3911 29.4154H56.2286L56.799 29.7169L57.6603 30.8384V31.6944L58.801 32.8283L59.0556 31.4538L59.905 31.1641V32.298L60.7663 32.8768H61.9071C62.1373 33.5552 62.4255 34.2131 62.7683 34.8425V35.144H60.5235L59.3102 34.2756H57.9635V35.144H57.6602L57.0898 34.8425L54.8207 34.2756V32.8769H51.6903L50.7922 33.4196H49.1179L47.6618 34.2756V35.6868L44.4951 37.6768L44.7985 38.5328H45.7085L45.4295 39.3889L44.8472 39.6543V41.9215L47.4072 44.7675H48.6206V44.4902L50.562 44.4908L51.1324 43.912H52.3458L52.8918 44.4908L54.6269 44.768L54.2022 47.0234L56.2043 50.1472L55.4156 52.1372V52.9933L55.986 53.5602V55.8156L57.1144 57.2386V58.9027H57.9881C54.556 63.0866 49.9088 66.1163 44.6799 67.5771C39.4516 69.0378 33.8965 68.859 28.7743 67.0645C23.652 65.2699 19.2119 61.948 16.0598 57.5513C12.9078 53.1552 11.1981 47.8988 11.164 42.5001C11.2214 38.9142 11.8985 35.365 13.1661 32.0076V33.7079L14.3069 34.2624V36.2525L15.3746 37.9657L15.9569 38.2554L16.2358 37.3993L15.3746 35.9876L15.0956 34.5647H15.666L16.0056 35.9876L17.4253 38.243L17.1464 38.7857L18.0077 40.2329L20.2887 40.7757V40.5102H21.1499V41.0772L21.7203 41.3668L22.8243 41.6323L24.5594 43.3568L26.5615 43.6223L26.8285 45.3226L25.4213 46.1549V47.5779L25.1299 48.4103L27.132 50.9915V51.8475H27.9933L29.692 53.2463V57.5035L30.2868 57.7689L29.692 59.7589L30.8328 61.1819L30.5658 63.1719L31.6941 65.1377L33.4292 66.5607L35.1035 66.8622V66.2952L33.9751 65.0892L33.9757 64.9325L34.2671 64.0765V63.5095H33.4297L33.1263 62.9426L33.6967 62.3756V62.0381L33.1263 61.7608V61.4953L34.2671 61.1938L35.6744 60.3615L36.2691 59.5054L37.9798 57.5154L37.4094 55.5254L37.9798 54.9826H39.4114L40.5398 54.1266L40.8556 51.0028L41.972 49.5798L42.2872 48.3738L41.0739 48.1083L40.5035 46.9744H38.2469L36.2691 46.4317V45.033L35.6743 44.2006H33.9756L33.1263 42.5122L32.265 42.2107L31.9735 42.5122H30.5663L29.9959 41.921L28.2608 41.6437L27.1325 43.0548L24.8515 42.7776L24.851 40.5222L23.1278 40.2449L23.6982 38.7977V38.255L21.7205 39.6059L20.2888 39.3404L19.9855 38.4844L20.2888 37.3505L20.8468 36.2166L22.5574 35.3605H25.7003L25.4213 36.2166L26.8286 36.7835L26.5615 35.0951L27.4228 34.5281L29.1334 33.3221V32.4897L30.8322 30.7894L32.5428 29.9334V29.6679L33.4285 28.7995H33.9745L34.2659 29.0767L34.5574 28.534H34.2659L33.6955 28.2444V27.6774L34.7886 27.678L35.0557 28.2449H35.359L36.2203 27.9434L36.5118 27.678H36.7907V28.2449L36.5118 28.5346V29.0773L37.9315 29.367H38.1985V28.8L37.0577 28.2455V27.9439L37.9315 27.4012V26.5452L37.0577 25.954L36.7907 24.5553L35.5773 25.1222H35.0069V23.9883L33.3326 23.4214L32.4469 23.9883V25.9541L31.1485 26.3396L30.5906 27.4611L30.0202 27.7384V26.0499H28.8068L27.9693 25.5072L27.6779 24.6512L30.2623 23.2524L31.0998 22.9391L31.4031 23.5179H31.9492V23.2524H32.8104V22.9391H32.519V22.3964H33.1013L33.6717 21.8294H33.9507L35.6494 21.5398L36.535 22.1067L34.5329 23.3127L36.8139 23.8555L37.3843 22.9994H38.5126L38.7916 22.167H37.9542V21.3228L35.3817 20.1889H33.6965L32.8352 20.7316L33.1267 21.9376H31.974L31.695 21.3707L32.8358 20.2368L31.1484 20.2373L30.5905 20.5146L30.3116 21.0816H30.8576L30.857 21.5155H29.6924L29.401 22.0825H27.9937L27.7023 21.2382H29.1339L29.9952 20.3822L29.4004 20.1049L28.8301 20.6476H27.7017L26.828 19.5261L25.4212 19.5256L23.698 20.9486H25.4212V21.2382L25.0815 21.5155H26.5132L26.7802 22.0824H25.0815V21.8052L23.698 21.5155L23.4191 21.2382H21.9874C26.3962 17.8463 31.8353 16.0469 37.4091 16.1368C41.5681 16.1869 45.6677 17.1205 49.434 18.874L51.4604 17.4025V17.403C49.5212 16.4054 47.4893 15.5977 45.3935 14.991C44.5561 14.7498 43.6948 14.5446 42.821 14.3761V14.3756C38.4117 13.5265 33.8626 13.7311 29.5481 14.9727C25.2341 16.2137 21.2787 18.4561 18.0074 21.5154C16.7241 22.4975 15.5704 23.6362 14.5736 24.9042C11.4063 29.1317 9.47423 34.1454 8.98985 39.3931C8.50504 44.6414 9.48657 49.9211 11.8267 54.6511C14.1667 59.3811 17.7744 63.3771 22.252 66.1999C26.7296 69.0227 31.9042 70.5625 37.2063 70.6503C42.5078 70.7386 47.7313 69.3706 52.3021 66.6979C56.8723 64.0246 60.6116 60.1509 63.1094 55.5012C64.0535 53.3961 64.8243 51.2182 65.4148 48.9887C65.6493 48.4583 65.7496 47.8785 65.7057 47.3002C66.035 45.712 66.2176 44.0973 66.2517 42.4761V39.6059C66.0199 36.8922 65.3395 34.2358 64.2378 31.7424L64.2367 31.743ZM60.8029 31.743V30.6215H61.0943C61.3977 30.8869 61.3977 31.1642 61.6647 31.743H60.8029ZM15.1425 28.3418V28.8964L14.0017 30.0303C14.2812 29.4639 14.876 28.8969 15.1425 28.3418ZM63.0702 36.5428V36.2656C63.3735 36.5429 63.3735 36.5429 63.3735 36.8325L63.0702 36.5428Z"
                    fill="#31006F" />
                </svg>
              </span>
              <p v-if="successSearch == 0 && !haveOrder" style="color: red; font-weight: bold">
                {{ errorSearchMessage }}
              </p>
              <p v-else-if="!haveOrder">
                {{ $t("youCanSearchHear") }}
              </p>
              <p v-else>
                <span>رقم الفاتورة : {{ detail_of_samsa_order.awbNo }}</span>
                <span style="display: block">كود الطرد : {{ orderCode }}</span>
              </p>
              <div class="input-search" v-if="!haveOrder">
                <h3>كود الطرد</h3>
                <div class="search-input">
                  <input v-model="orderCode" @keyup.enter="getStatusOrder()"
                    placeholder="برجاء البحث بكود الطرد مثال : 1234567" />
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10.176" height="10.329" viewBox="0 0 10.176 10.329">
                      <g id="search" transform="translate(-2.8 -2.561)">
                        <circle id="Ellipse_274" data-name="Ellipse 274" cx="3.844" cy="3.844" r="3.844"
                          transform="translate(3.3 3.061)" fill="none" stroke="#b9b9c3" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="1" />
                        <line id="Line_69" data-name="Line 69" x1="2.222" y1="2.222" transform="translate(10.046 9.96)"
                          fill="none" stroke="#b9b9c3" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1" />
                      </g>
                    </svg>
                  </i>
                </div>
                <button v-if="!loadingSearch" @click="
                  getStatusOrder(),
                  googleEventTrack(
                    'الضغط على زر البحث اللي  موجود ف البحث السريع تحت ع الشمال',
                    'home',
                    'quick_seach_in_home_page'
                  )
                  " class="btn-search">
                  {{ $t("lookFor") }}
                </button>
                <button v-if="loadingSearch" class="btn-search">
                  <spinner-color />
                </button>
              </div>
              <div class="input-search" v-else-if="successSearch == 1 && haveOrder">
                <h3>{{ $t("statusOfOrder") }}</h3>
                <div class="search-input">
                  <!-- @click="$router.push(`/OrderDetails/`+detail_of_order.code).catch(() => {})"  -->
                  <input class="text-center" style="
                      margin-bottom: 0.75rem !important;
                      border-color: #31006f !important;
                      cursor: pointer;
                    " readonly />
                  <span class="order-status cursor-pointer">
                    <span>{{ detail_of_samsa_order.Activity }}</span>
                  </span>
                  <div v-if="$acl.not.check('isPublicCompany')">
                    <p>
                      <span style="font-size: 0.9rem">الموقع : </span>{{ detail_of_samsa_order.Location }}
                    </p>
                    <p>
                      <span style="font-size: 0.9rem">تاريخ الإرسال : </span>
                      <span style="
                          display: inline-block;
                          direction: ltr;
                          color: inherit;
                        ">{{ detail_of_samsa_order.Date }}</span>
                    </p>
                    <p>
                      <span style="font-size: 0.9rem">تفاصيل الطرد : </span>{{ detail_of_samsa_order.Details }}
                    </p>
                  </div>
                </div>
                <button @click="(haveOrder = false), (orderCode = '')" class="new-search">
                  {{ $t("newSearch") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import globalMixin from "@/mixins/mixins.js";
import orderStatusMixin from "@/mixins/orderStatus.js";
import DataTableOrder from "@/views/components/table-components/DataTableOrder.vue";
import helper from "@/mixins/helper.js";
import { Pie } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  ArcElement,
  LinearScale
);
import aclAccess from "@/mixins/hasAccess";
import gTag from "@/mixins/gtag.js";
import Modal from "@/layouts/components/Modal.vue";
import ModalNotification from "@/layouts/components/ModalNotification.vue";
import ModalAddVue from "@/layouts/components/ModalAdd.vue";
import TurboFeatures from "./components/TurboFeatures.vue";
import TurboShop from "./components/TurboShop.vue";
import surveyInput from "./components/surveyInput.vue";
import Axios from 'axios';

export default {
  mixins: [globalMixin, orderStatusMixin, helper, aclAccess, gTag],
  data() {
    return {
      showBalance: false,
      partial_return: false,
      spin: false,
      isModalOpen: false,
      currentSlide: 1,
      totalSlides: 5,
      orderStatus: "",
      orderCode: "",
      isSearch: false,
      haveOrder: false,
      addNewDataSidebar: false,
      chartData: {},
      orderRequestsData: {},
      sumChart: 0,
      chartOptions: {
        plugins: {
          title: {
            display: false,
          },
          tooltips: {},
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "right",
            textDirection: "rtl",
            rtl: true,
            usePointStyle: true,
            labels: {
              usePointStyle: true,
              boxWidth: 10,
              boxHeight: 10,
              font: {
                family: "Cairo",
              },
            },
          },
          responsive: true,
        },
      },
      header: [
        { header: "dateOfRegistration", key: "created_at" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "collectedAmount", key: "amount" },
        { header: "actions", key: "actions" },
      ],
      pageName: "last/order",
      titlePage: "اخر الطرود المحفوظة",
      body: [
        "created_at",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "area",
        "amount",
      ],
      type: 2,
      loadHome: true,
      successSearch: null,
      errorSearchMessage: "",
      showRequestsModal: false,
      loadingSearch: false,
      image: process.env.VUE_APP_CONFIGS_HOME_PAGE_IMAGE,
      logoWhite: process.env.VUE_APP_CONFIGS_MAIN_LOGO_WHITE,
      showModal: false,
      showNumbersModal: false,
      updateClientData: "",
      loadingUpdateClientData: false,
      activeSurveysModal: false,
      isFreezed: JSON.parse(localStorage.getItem('userData')).isFreezed == 1,
    };
  },
  watch: {},
  components: {
    SpinnerColor,
    DataTableOrder,
    Pie,
    Modal,
    ModalNotification,
    TurboFeatures,
    TurboShop,
    ModalAddVue,
    surveyInput,
  },
  computed: {
    ...mapGetters("dataList", [
      "detail_of_order",
      "chart",
      "success_api",
      "err_msg",
    ]),
    ...mapGetters("userData", [
      "client",
      "total_supplied_balance",
      "next_supply",
      "total_balance",
      "user",
      "sub_user",
      "is_main_client",
    ]),
    ...mapGetters("samsaApi", [
      "detail_of_samsa_order",
      "error_samsa_order",
      "success_api_samsa_order",
    ]),
    ...mapState("auth", ["phone1", "phone2"]),
    ...mapState("survey", [
      "surveyData",
      "err_survey",
      "success_submit_survey",
      "available_surveys",
    ]),
    isFormValid() {
      if (!this.errors.any()) {
        return true;
      }
      return false;
    },
    checkAuthHasShowModalChangePrice() {
      let authUser = this.user;
      let subUsers = this.sub_user;
      let authIsMainClientOrSubUser = this.is_main_client;

      if (authIsMainClientOrSubUser) {
        return true;
      }

      let authSubUser = subUsers.find((subUser) => subUser.id == authUser.id);

      if (authSubUser && authSubUser.permissions_flags) {
        return authSubUser.permissions_flags.show_modal_change_request_price;
      }

      return false;
    },
  },
  methods: {
    ...mapActions("dataList", [
      "orderDetails",
      "fetchChart",
      "fetchDataListItems",
    ]),
    ...mapActions("samsaApi", ["internationalSearch"]),
    ...mapActions("auth", ["confirmRestored"]),
    ...mapActions("survey", ["getSurvey", "submitSurvey"]),
    ...mapActions("userData", ["userBalance"]),
    async fetchBalance() {
      this.spin = true
      await this.userBalance()
      this.showBalance = true
      this.spin = false
    },
    // get status of international order
    async getStatusOrder() {
      if (this.orderCode != "") {
        this.isSearch = true;
        this.loadingSearch = true;
        await this.internationalSearch(this.orderCode);
        this.loadingSearch = false;
        this.isSearch = false;
        if (this.success_api_samsa_order) {
          this.haveOrder = true;
          this.successSearch = 1;
          this.errorSearchMessage = "";
        } else {
          this.successSearch = 0;
          this.errorSearchMessage = this.error_samsa_order;
        }
      } else {
        this.successSearch = 0;
        this.errorSearchMessage = " برجاء ادخال كود طرد اولاً";
      }
    },
    closeModal() {
      this.isModalOpen = false;
      // Restore scrolling
      document.body.style.overflow = 'auto';
    },
    nextSlide() {
      if (this.currentSlide < this.totalSlides) {
        this.currentSlide++;
      } else {
        this.closeModal();
      }
    },
  },

  // close modal of adjust shipping costs || close modal of technical support numbers
  closePopup() {
    this.showModal = false;
    this.showNumbersModal = false;
    this.isFreezed = false;
  },

  // submit survey data
  async submitData() {
    this.$validator.validateAll().then(async (result) => {
      if (result) {
        this.loadingUpdateClientData = true;
        await this.submitSurvey({
          survey_id: this.surveyData.survey_id,
          survey_answers: this.surveyData.survey_type == 'checkbox' ? this.updateClientData : [this.updateClientData],
        });
        this.loadingUpdateClientData = false;
        if (this.success_submit_survey == 1) {
          this.notifySuccess("editToast");
          if (this.available_surveys) {
            this.loadingUpdateClientData = true;
            await this.getSurvey();
            this.loadingUpdateClientData = false;
          } else {
            localStorage.setItem("availableSurveys", 0);
            this.activeSurveysModal = false;
          }
        }
      }
    });
  },
  // get order change price requests
  async getOrderChangeRequestsPrice() {
    if (!this.checkAuthHasShowModalChangePrice) {
      return;
    }

    this.spin = true;
    let { data } = await Axios.get(process.env.VUE_APP_BASE_URL + 'order/get_order_change_requests');


    if (data.order_change_requests.length > 0) {
      this.showRequestsModal = true;

      this.orderRequestsData = data.order_change_requests[0];
    } else {
      this.showRequestsModal = false;
    }

    this.spin = false
  },
  // change status order change price requests
  async changeStatusOrderChangeRequestsPrice(isAccepted) {
    this.spin = true;
    let { data } = await Axios.post(process.env.VUE_APP_BASE_URL + 'order/process_order_change_requests', {
      order_id: this.orderRequestsData.order_id,
      accept: isAccepted,
      partial_return: this.orderRequestsData.partial_return,
      socket_id: this.$socket.id
    });
    this.$vs.notify({
      title: 'نجاح',
      text: data.message,
      color: 'success',
      iconPack: 'feather',
      icon: 'icon-check',
    });
    await this.getOrderChangeRequestsPrice();
    this.spin = false
  },

  beforeDestroy() {

    // Clean up the socket listener when the component is destroyed
    this.$socket.off('close-modal-for-users-when-user-take-action');
  },
  async mounted() {
    this.isModalOpen = true;

    this.$socket.emit("join", { name: 'close-modal-for-users-when-user-take-action' });

    this.$socket.on('close-modal-for-users-when-user-take-action', () => {
      this.showRequestsModal = false;
    });

    await this.getOrderChangeRequestsPrice();
  },
  async created() {
    if (localStorage.getItem("availableSurveys") > 0) {
      await this.getSurvey();
      this.activeSurveysModal = true;
    }
    let credentials = {
      page: "order/saved",
      pageNum: null,
      itemsPerPage: 6,
    };
    // fetch saved orders
    await this.fetchDataListItems(credentials);

    // fetch data about client works
    await this.fetchChart();
    this.sumChart =
      parseInt(this.chart.total_given) +
      parseInt(this.chart.total_return_OnSender) +
      parseInt(this.chart.total_return_OnReciever) +
      parseInt(this.chart.total_return_cancel);
    this.chartData = {
      labels: ["تم التسليم", "علي الراسل", "مدفوع", "إلغاء"],
      datasets: [
        {
          backgroundColor: ["#31006f", "#faae00", "#28C76F", "#d1002d"],
          data: [
            Math.ceil((this.chart.total_given / this.sumChart) * 100),
            Math.ceil((this.chart.total_return_OnSender / this.sumChart) * 100),
            Math.ceil(
              (this.chart.total_return_OnReciever / this.sumChart) * 100
            ),
            Math.ceil((this.chart.total_return_cancel / this.sumChart) * 100),
          ],
        },
      ],
    };
    this.loadHome = false;
    this.showModal = parseInt(localStorage.getItem("restored"));
    if (this.showModal) this.confirmRestored();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_home.scss";
</style>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";

.width {
  width: 30%;
}

.translate {
  transform: translateY(300%);
  z-index: 3;
}

.blur {
  filter: blur(3px);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-vip-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 650px;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
}

.rtl-list {
  direction: ltr;
  list-style-position: inside;
  list-style-type: disc;
}

.rtl-list li::marker {
  font-weight: bold;
}

/* Slides styling */
.slides-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.slide {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  direction: rtl;
  /* For Arabic text */
}

.slide-content {
  padding-bottom: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.slide-image-container {
  background-color: #31006F;
  width: 100%;
}

.slide-image {
  width: 80%;
  height: auto;
  max-height: 200px;
  margin-bottom: 20px;
}

.next-btn {
  background-color: #5b21b6;
  /* Purple color similar to image */
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 30px;
  margin-top: 20px;
  cursor: pointer;
  font-weight: bold;
}

/* Dots navigation */
.slide-dots {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
}

.dot.active {
  background-color: #5b21b6;
  width: 20px;
  border-radius: 10px;
}

/* Transition effects */
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

.slide-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}

/* Button to open modal */
.open-modal-btn {
  background-color: #5b21b6;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
}
</style>
